import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "../cart/CartContext"; // 🛒 נוסיף את הקארט

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { items } = useCart(); // 🛒 נביא את הפריטים בעגלה

  const hasCartItems = items && items.length > 0;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      toast.success("Welcome back 🌿");

      // 🧠 אם יש מוצרים בעגלה → חוזר לעגלה, אחרת → products
      navigate(hasCartItems ? "/cart" : "/products");
    } catch (err) {
      toast.error(
        "Login failed: " + err.message.replace("Firebase:", "").trim()
      );
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      // 🔥 לוודא שיש מסמך ב-Firestore עבור המשתמש
      const userRef = doc(db, "users", result.user.uid);
      const snap = await getDoc(userRef);

      if (!snap.exists()) {
        await setDoc(userRef, {
          email: result.user.email,
          signUpStage: "detailsIncomplete",
          createdAt: new Date(),
        });
      }

      toast.success("Logged in with Google 🌿");

      // 🧠 גם כאן – אם יש מוצרים בעגלה → לעגלה, אחרת → products
      navigate(hasCartItems ? "/cart" : "/products");
    } catch (err) {
      toast.error("Google login failed: " + err.message);
    }
  };

  const buttonText = "Login";
  const googleHandler = handleGoogleLogin;

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f9f9f9, #f0f4f7)",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: 420,
          padding: "40px 30px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            marginBottom: 20,
            color: "#222",
            letterSpacing: "0.5px",
            fontWeight: 600,
          }}
        >
          Log in to your account
        </h2>

        <form
          onSubmit={handleLogin}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={inputStyle}
          />

          {/* 🔥 שני הכפתורים – מיושרים בול */}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <button
              type="submit"
              disabled={loading}
              style={{
                ...buttonStyle,
                background: loading
                  ? "#ccc"
                  : "linear-gradient(90deg, #222, #444)",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Logging in..." : buttonText}
            </button>

            <button
              type="button"
              onClick={googleHandler}
              style={{
                ...buttonStyle,
                background: "#fff",
                color: "#444",
                border: "1px solid #ccc",
                marginTop: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                alt="Google"
                style={{ width: 20, height: 20 }}
              />
              Continue with Google
            </button>
          </div>
        </form>

        <p style={{ marginTop: 20, color: "#555" }}>
          Don’t have an account?{" "}
          <span
            onClick={() => navigate("/signup")}
            style={{
              color: "#0078ff",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Sign up
          </span>
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  display: "block",
  width: "100%",
  maxWidth: 300,
  margin: "10px auto",
  padding: "12px 14px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "15px",
  outline: "none",
  textAlign: "center",
  transition: "border 0.2s ease",
};

const buttonStyle = {
  width: "100%",
  maxWidth: 300,
  padding: "12px",
  border: "none",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 600,
  transition: "opacity 0.2s ease",
};
